import { render, staticRenderFns } from "./PlanosList.vue?vue&type=template&id=1e020288"
import script from "./PlanosList.vue?vue&type=script&lang=js"
export * from "./PlanosList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports